module.exports = __webpack_public_path__ + "img/17-18.e99c525d.jpg";